export function last<T>(array: readonly T[]): T | undefined {
  return array[array.length - 1]
}

export function middle<T>(array: readonly T[], right = false): T | undefined {
  const base = right ? array.length : array.length - 1
  return array[Math.trunc(base / 2)]
}

export function max<T>(array: readonly T[]): T | undefined {
  let max: T | undefined = undefined
  for (const it of array) {
    if (!max || max < it) max = it
  }
  return max
}

export function prefer<T>(array: T[], value: T): T {
  if (array.includes(value)) return value
  return array[0] ?? value
}

export function times(length: number): number[] {
  return Array.from({ length }, (_, index) => index)
}

export function uniq<T>(array: T[]): T[] {
  return Array.from(new Set(array))
}

export function mix(...arrays: string[][]): string[] {
  const len = Math.max(...arrays.map(array => array.length))
  const mix: string[] = []
  for (let n = 0; n < len; ++n) {
    for (const array of arrays) {
      const value = array[n]
      if (value) mix.push(value)
    }
  }
  return mix
}
